import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasContainer = ({ children, className, maxWidth = 'lg', ...props }) => {
  const maxWidthMap = {
    xs: 'max-w-xs',
    sm: 'max-w-sm',
    md: 'max-w-3xl',
    lg: 'max-w-5xl',
    xl: 'max-w-7xl',
    // boolean false is coerced to string key 'false' by JS — intentional
    false: 'max-w-none'
  }
  return (
    <div className={cn('w-full py-2', maxWidthMap[maxWidth] || 'max-w-5xl', className)} {...props}>
      {children}
    </div>
  )
}

AdasContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false, 'false'])
}
